import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  formatBody,
} from 'services/RequestService/helpers';

export const claimUserBehavioralDiscount = async ({
  params: { userBehavioralDiscountId, menuSlug, meal_servings, meal_option_selections },
}) => {
  const response = await fetchWrapper(
    hcUrlV3(`/weekly_baskets/${menuSlug}/user_behavioral_discount_claims`),
    buildOpts({
      method: 'PATCH',
      body: formatBody({
        userBehavioralDiscountClaim: {
          userBehavioralDiscountId,
          meal_servings,
          meal_option_selections,
        },
      }),
    })
  );

  return handleResponse(response);
};
